import React  from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import '../../style/console.css'

export default function ErrorMsg (props) {
    const { referrer } = props || {}
    const errorMsg = referrer && referrer.errorMsg || __('console_create_error_org_not_found')

    return <React.Fragment>
        <div className="adobe-easybake-form-help-text">{errorMsg} If the error persists, <a href={__('url_zendesk_ticket_new')} target="_blank" rel="noreferrer">please submit a ticket</a> for the further assistance.</div>
    </React.Fragment>
}
